$.extend({
  clearErrors: (form) => {
    form.find('.is-error').removeClass('is-error').next('p.m-frmError').remove()
  },
  showErrors: (form, errors, options) => {
    $.clearErrors(form)
    options = $.extend({
      base: '',
      replaces: {},
      top: true
    }, options)
    if (options.top) {
      form.closest('.m-modalContent').scrollTop(0)
    }
    const replaceName = (name) => {
      name = name in options.replaces ? options.replaces[name] : name
      return options.base ? `${options.base}[${name}]` : name
    }
    $.each(errors, (name, messages) => {
      let parent = form.find(`[name='${replaceName(name)}']`).closest('div[class*="m-frm"]').addClass('is-error')
      $.each(messages, (index, message) => {
        parent = parent.after($('<p>').addClass('m-frmError').text(message))
      })
    })
  },
  fitBounds: (map, bounds, padding) => {
    const execute = () => {
      google.maps.event.addListenerOnce(map, 'idle', () => div.attr('data-loaded', 'true'))
      map.fitBounds(bounds, padding)
    }
    const div = $(map.getDiv())
    if (div.is(':visible')) {
      execute()
    } else {
      map.fitBounds(bounds, padding)
      map.addListener('idle', () => {
        if (div.is(':visible')) {
          google.maps.event.clearListeners(map, 'idle')
          execute()
        }
      })
    }
  }
})

$(document).on('turbolinks:load', () => {
  $('button[type="button"].form-submit').each((index, element) => {
    $(element).on('click', (event) => {
      const form = event.target.form
      if (form.checkValidity()) {
        form.submit()
      } else {
        if (HTMLFormElement.prototype.reportValidity) {
          form.reportValidity()
        } else {
          const dummy = document.createElement('button')
          dummy.style.display = 'none'
          form.appendChild(dummy)
          dummy.click();
          form.removeChild(dummy)
        }
      }
    })
  })
})
